// Forgot Password Page Component
// LazySEM Frontend - Forgot password page

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { ForgotPasswordForm } from '../../auth/components/PasswordReset/ForgotPasswordForm';
import styles from './ForgotPassword.module.css';

const ForgotPassword: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [initialCheckDone, setInitialCheckDone] = useState(false);

  // Check if user is authenticated on mount only
  useEffect(() => {
    // Check localStorage for token to determine initial auth state
    const token = localStorage.getItem('access_token');
    if (token && user) {
      navigate('/dashboard', { replace: true });
    }
    setInitialCheckDone(true);
  }, [user, navigate]);

  // Show loading only during initial check
  if (!initialCheckDone) {
    return (
      <div className={styles.forgotPassword}>
        <div className={styles.loading}>
          <div className={styles.spinner} />
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  // Don't render if user is authenticated
  if (user) {
    return null;
  }

  return (
    <div className={styles.forgotPassword}>
      <div className={styles.container}>
        <ForgotPasswordForm />
      </div>
    </div>
  );
};

export default ForgotPassword;